import * as React from "react";
import { Routes } from "../../../common/routing";
import Socials from "./Socials";

const buildDocUrl = (docId) =>
  `${Routes.Website.Pages.Docs.Base}?id=${docId}`;

export const Footer = (props) => {
  const platformWalkthrough = Routes.Website.Pages.Docs.PlatformWalkthrough;
  const columns = [
    {
      title: "Platform",
      items: [
        { name: "Platform-as-a-Service", href: buildDocUrl(platformWalkthrough.PaaS) },
        { name: "Internal Digital Platforms", href: buildDocUrl(platformWalkthrough.InternalDigitalPlatforms) },
        { name: "Managed APIs", href: buildDocUrl(Routes.Website.Pages.Docs.ManagedApiService.GettingStarted) },
        { name: "AI Agents", href: buildDocUrl(Routes.Website.Pages.Docs.Platform.AIAgentReadiness) },
        { name: "MCP Servers", href: buildDocUrl(Routes.Website.Pages.Docs.ManagedApiService.McpIntegration) },
      ],
    },
    {
      title: "Solutions",
      items: [
        { name: "Internal Digital Platforms", href: buildDocUrl(platformWalkthrough.InternalDigitalPlatforms) },
        { name: "API Monetisation", href: buildDocUrl(platformWalkthrough.ApiMonetisation) },
        { name: "Digital Transformation", href: buildDocUrl(platformWalkthrough.DigitalTransformation) },
        { name: "Brownfield Platforms", href: buildDocUrl(platformWalkthrough.BrownfieldPlatforms) },
        { name: "Multi-Cloud Operations", href: buildDocUrl(platformWalkthrough.MultiCloudOperations) },
      ],
    },
    {
      title: "Case Studies",
      items: [
        { name: "Government Agency", href: buildDocUrl(platformWalkthrough.PublicGovernmentAgency) },
        { name: "Healthcare Conglomerate", href: buildDocUrl(platformWalkthrough.HealthcareConglomerate) },
        { name: "Large Retailer", href: buildDocUrl(platformWalkthrough.LargeRetailer) },
        { name: "Superannuation", href: buildDocUrl(platformWalkthrough.SuperannuationCompany) },
      ],
    },
    {
      title: "Resources",
      items: [
        { name: "Documentation", href: Routes.Website.Pages.Docs.Base },
        { name: "Blog", href: Routes.Website.Pages.Blogs.Directory },
        { name: "Latest updates", href: Routes.Website.Pages.Latest.Home },
        { name: "Pricing", href: Routes.Website.Pages.Conversion.Prices },
      ],
    },
    {
      title: "Support",
      items: [
        { name: "Talk to an expert", href: Routes.Website.Pages.Conversion.TalkToExpert },
        { name: "Contact sales", href: Routes.Website.Pages.Conversion.TalkToExpert },
        { name: "Status", href: Routes.Website.Pages.Others.Status },
      ],
    },
  ];

  return (
    <footer
      className="relative bg-gray-900"
      aria-labelledby="footer-heading"
    >
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>

      <style>{`
        .pf-footer-heading {
          font-size: 0.95rem;
          font-weight: 600;
          color: #ffffff;
          letter-spacing: -0.005em;
        }
        .pf-footer-link {
          color: #cbd5e1;
          font-size: 0.875rem;
          line-height: 1.5;
          transition: color 180ms ease;
        }
        .pf-footer-link:hover { color: #ffffff; }
        .pf-footer-intro {
          color: #cbd5e1 !important;
          font-size: 0.875rem;
          line-height: 1.65;
        }
        .pf-footer-divider { background-color: rgba(255,255,255,0.08); }
        .pf-footer-meta {
          color: #94a3b8;
          font-size: 0.8rem;
          line-height: 1.6;
        }
        .pf-footer-meta a {
          color: #94a3b8;
          transition: color 180ms ease;
        }
        .pf-footer-meta a:hover { color: #ffffff; }
      `}</style>

      <div className="mx-auto max-w-7xl px-6 pt-20 pb-10 lg:px-8 lg:pt-24">
        {/* Main row: brand + 5 columns */}
        <div className="grid grid-cols-1 gap-y-12 lg:grid-cols-12 lg:gap-x-10">
          <div className="lg:col-span-3">
            <img
              className="h-8"
              src="https://cdn.pellerex.com/public/ecosystem/web/home/pellerex-logo.png"
              alt="Pellerex Pty. Ltd."
            />
            <p className="pf-footer-intro mt-5 max-w-xs">
              Launch enterprise APIs, Agents and MCP Servers instantly — fully
              automated, with built-in governance.
            </p>
            <div className="mt-6">
              <Socials />
            </div>
          </div>

          <div className="lg:col-span-9 grid grid-cols-2 gap-x-8 gap-y-10 sm:grid-cols-3 lg:grid-cols-5">
            {columns.map((col) => (
              <div key={col.title}>
                <h3 className="pf-footer-heading">{col.title}</h3>
                <ul role="list" className="mt-5 space-y-3">
                  {col.items.map((item) => (
                    <li key={item.name}>
                      <a href={item.href} className="pf-footer-link">
                        {item.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 lg:mt-20">
          <div className="pf-footer-divider h-px w-full" />
          <div className="mt-6 flex flex-col-reverse gap-y-4 sm:flex-row sm:items-center sm:justify-between">
            <p className="pf-footer-meta">
              &copy; {new Date().getFullYear()} Pellerex Pty Ltd. All rights reserved.
            </p>
            <p className="pf-footer-meta">
              <a href={Routes.Website.Pages.Others.Policies}>Privacy</a>
              <span className="mx-2 text-gray-600">·</span>
              <a href={Routes.Website.Pages.Others.Terms}>Terms</a>
              <span className="mx-2 text-gray-600">·</span>
              <a href="#">Cookies</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
